module.exports = __webpack_public_path__ + "account/assets/filter.4bbfe694.svg";